module.exports = __webpack_public_path__ + "img/empty_cart.ffc5cf83.png";